import { useContext } from "react";
import { ThemeContext } from "styled-components";
import Traditional from "../themes/Traditional";
export const useTheme = () => {
    const Theme = useContext(ThemeContext);
    if (!!Theme) {
        return { Theme };
    }
    else {
        return { Theme: Traditional };
    }
};
//# sourceMappingURL=useTheme.js.map